<template>
<div class="chapter">
<div class="inner_page">
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">Fire and Flint</span></h1>
<p class="p_normal"> </p>
<p class="p_norm-noindent">By Andrew Grey</p>
<p class="p_normal"> </p>
<p class="p_normal">Jordan Erichsohn suspects something is rotten about his boss, Judge Crawford. Unfortunately he has nowhere to turn and doubts anyone will believe his claims—least of all the handsome deputy, Pierre Ravelle, who has been assigned to protect the judge after he received threatening letters. The judge has a long reach, and if he finds out Jordan’s turned on him, he might impede Jordan adopting his son, Jeremiah.</p>
<p class="p_normal">When Jordan can no longer stay silent, he gathers his courage and tells Pierre what he knows. To his surprise and relief, Pierre believes him, and Jordan finds an ally… and maybe more. Pierre vows to do what it takes to protect Jordan and Jeremiah and see justice done. He’s willing to fight for the man he’s growing to love and the family he’s starting to think of as his own. But Crawford is a powerful and dangerous enemy, and he’s not above ripping apart everything Jordan and Pierre are trying to build in order to save himself….</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?34c1d140